export enum Permission {
  CustomersView = 'customers.view',
  CustomersUserImpersonationModifyAccess = 'customers_user_impersonation.modify',
  CustomersPrivacyRequestsModifyAccess = 'customers_privacy_requests.modify',
}
